import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";

// Containers
const TheAdminContainer = () =>
    import ('../containers/admin/TheAdminContainer')
    //Admin pages
const Dashboard = () =>
    import ('../view/admin/Dashboard')
const AllUser = () =>
    import ('../view/admin/roleManage/AllUser')
const VerifyCitizenID = () =>
    import ('../view/admin/roleManage/VerifyCitizenID')
const Banner = () =>
    import ('../view/admin/homePageManagement/Banner')
const PopularCourse = () =>
    import ('../view/admin/homePageManagement/PopularCourse')
const NewCourse = () =>
    import ('../view/admin/homePageManagement/NewCourse')
const FreeCourse = () =>
    import ('../view/admin/homePageManagement/FreeCourse')
const CoursesOverview = () =>
    import ('../view/admin/courseManagement/CoursesOverview')
const CourseRecordDetails = () =>
    import ('../../src/components/adminComponent/coursemanagement/courserecorddetail/CourseRecordOverviewDetail')
const Examination = () =>
    import ('../view/admin/courseManagement/Examination')
const CertificateManagement = () =>
    import ('../view/admin/achievement/CertificateManagement')
const ReportAndExport = () =>
    import ('../view/admin/ReportAndExport')

const ifAuthenticated = (to, from, next) => {
    if (store.getters["auth/userStatus"]) {
        next()
        return
    }
    next('/homepage')
}
export default [
    {
        path: '/admin',
        name: 'Admin',
        component: TheAdminContainer,
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            component: Dashboard
        }]
    },
    {
        path: '/role-management',
        name: 'Role Management',
        component: TheAdminContainer,
        children: [{
            path: 'all-user',
            name: 'All User',
            component: AllUser
        }, {
            path: 'verify-citizen-id',
            name: 'Verify Citizen ID',
            component: VerifyCitizenID
        }]
    },
    {
        path: '/home-page-management',
        name: 'Home Page Management',
        component: TheAdminContainer,
        children: [{
            path: 'banner',
            name: 'Banner',
            component: Banner
        }, {
            path: 'popular-course',
            name: 'Popualr Course',
            component: PopularCourse
        }, {
            path: 'new-course',
            name: 'New Course',
            component: NewCourse
        }, {
            path: 'free-course',
            name: 'Free Course',
            component: FreeCourse
        }]
    },
    {
        path: '/course-management',
        name: 'Course Management',
        component: TheAdminContainer,
        children: [{
            path: 'courses-overview',
            name: 'Course Overview',
            component: CoursesOverview
        }, {
            path: 'course-detail',
            name: 'Course Detail',
            component: CourseRecordDetails
        }, {
            path: 'examination',
            name: 'Examination',
            component: Examination
        }]
    },
    {
        path: '/report-and-export',
        redirect: '/report-and-export',
        component: TheAdminContainer,
        children: [{
            path: '/report-and-export',
            name: 'Report And Export',
            component: ReportAndExport
        }]
    },
    {
        path: '/achievement',
        name: 'Achievement',
        component: TheAdminContainer,
        children: [{
            path: 'certificate-management',
            name: 'Certificate Management',
            component: CertificateManagement
        }]
    }
]